<template>
   <div>
      <div class="container">
         <div class="row justify-content-between pb-5">
            <div class="col-12 col-md-6">
               <h2>{{$route.params.slug}}</h2>
                  <div class="input-group">
                     <!--label for="field-cerca" class="sr-only d-none active" style="transition: none 0s ease 0s;">{}</label>
                        <input type="search" id="field-cerca" name="q" placeholder="Cerca" class="form-control"  @keyup.prevent="search" v-model="query" />           

                        <div class="input-group-append reset">
                           <button class="btn no-radius btn-minimal-padding" type="reset">
                              <svg class="icon icon-sm"><use xlink:href="@/assets/img/sprite.svg#it-close-big"></use></svg>
                           </button>
                        </div>
                     <button class="btn btn-primary btn-minimal-padding" type="submit"><svg class="icon icon-sm"><use xlink:href="@/assets/img/sprite.svg#it-search"></use></svg></button-->
                  </div>
            </div>
         </div>
      </div>

      <section id="area-specializzazione" class="section section-inset-shadow pb-0 pt-2 pb-5" v-if="query !== ''">
         <div id="content" class="container pt-2 pb-4 px-0 px-md-3 pt-5">
            <div class="row justify-content-center">
               <!--div class="col-12 col-md-3">
                  <div class="panel mt-4" v-for="(item, key, index,) in facets" :key="index" :ref="`card_${index}`">
                     <div  v-if="item.buckets.length > 0">
                        <h5 class="font-weight-semibold">{{key}}</h5>
                        <facets :facetGroup="item.buckets" :decode="key == 'S3' || key == 'Aree Specializzazione' ? true : false"></facets>                     
                     </div>
                  </div>
               </div-->
            
               <div class="col-12" v-if="pager.totalResults > 0">

                  <div class="d-flex small align-items-center justify-content-between">
                     <div class="text-left">Trovati {{data.total.value}} risultati</div>
                     <div class="align-items-center d-flex">
                        <span>Ordina per </span>
                        <b-form-select class="form-control-sm small bordered ml-1" value-field="value" text-field="text" v-model="sortBy.selected" :options="sortBy.sorting" @change="changeSorting"/>
                     </div>                                  
                  </div>
                  <div class="row">
                     <!-- Call cards -->                                                            
                     <result v-for="(item, index) in data.hits" :news="{item}" :key="index" :ref="`card_${index}`"></result>
                  </div>
                  <pager :pager="pager" use-router v-if="pager.totalResults > 0" v-on:listenChangePage="changePage($event)" v-on:listenLimitChange="setLimit($event)"/>
               </div>

               <div class="col-12 col-md-8 justify-content-center"  v-if="!pager.totalResults > 0">
                  <div class="alert alert-danger m-4">
                     La ricerca di - <b>{{query}}</b> - non ha prodotto risultati in nessun risultato.
                  </div>
               </div>
            </div>
         </div>
      </section>   
  </div>
</template>
<script>
import {getDate} from '@/service';
import axios from 'axios';
import result from '@/components/Results';
import pager from '@/components/Pager';
//import facets from '@/components/Facets';

export default {
   name: "argomenti",

   components:{
      result,
      pager        
   },

   props: {
   },

   data() {
      return {
         tipologia: [],
         argomento: [],
         argomenti: [],
         filters: [],
         query: this.$route.params.slug,
         pager:{
            currentPage: 1,
            totalResults: 0,
            from: 0,
            limit: 9
         },              
         sortBy:{
            selected: '_score',
            sorting: [
               { value: "_score", text: 'Rilevanza' },
               { value: {"data.titolo.iv.keyword": {"order" : "asc"}}, text: 'Titolo A-Z' },
               { value: {"data.titolo.iv.keyword": {"order" : "desc"}}, text: 'Titolo Z-A' },
               { value: {"created": {"order" : "desc"}}, text: 'Più recente' },
               { value: {"created": {"order" : "asc"}}, text: 'Meno recente' },
            ]
         },       
         sort:[{"_score": {"order":"desc"}}],   
         data: [],
         facets: []         
      }
   },   

   methods:{
      transformDate: function(val){
         return getDate(val);
      },
      //changeLimit(value){
      //   //console.log('called from child : ' + value);
      //},
      getArgument(id){
         return this.$root.getS3Category(id);
      },  
      getPath(id){         
         let areaS3 = this.$root.getS3Category(id);
         return areaS3[id].linkUrl;
      },
      getNameSezione(id){         
         let areaS3 = this.$root.getS3Category(id);
         return areaS3[id].nome;
      },
      search(e) {            
         this.filters = [({term : {"data.argomenti.iv.keyword": this.query }})];
         if(e){
            e.preventDefault();
         }
         axios.post(process.env.VUE_APP_ESEARCH_PROTOCOL+process.env.VUE_APP_ESEARCH+'/'+process.env.VUE_APP_ESEARCH_INDEX+'/_search',
            {
               "size": this.pager.limit,
               "from" : this.pager.from,   
               "track_scores": true,
               "aggs": {
                "S3": {
                  "terms": {
                    "field": "data.s3.iv.keyword",
                    "size": 10
                  }
                },
                "Aree Specializzazione": {
                  "terms": {
                    "field": "data.areeSpecializzazione.iv.keyword",
                    "size": 10
                  }
                },
                "Argomenti": {
                  "terms": {
                    "field": "data.argomenti.iv.keyword",
                     "size": 40
                  }
                }
               },
               "_source": {
                  "excludes": [ "timestamp", "appId", "createdBy", "actor", "version", "partition"]
               },                    
               "sort" : this.sort,          
               "query": {
                  "bool": {
                     "must": {
                       "simple_query_string": {
                         "query": '*',
                         "flags": "ALL",
                         "fuzzy_transpositions": true,
                         "fuzzy_max_expansions": 50,
                         "fuzzy_prefix_length": 0,
                         "minimum_should_match": 1,
                         "default_operator": "or",
                         "lenient": true,
                         "analyzer": "standard",
                         "quote_field_suffix": "",
                         "analyze_wildcard": false,
                         "auto_generate_synonyms_phrase_query": true
                       }
                     },
                     
                     "filter": this.filters
                  }
               }                  
            },
            {
               auth: { 
                  username: process.env.VUE_APP_ESEARCH_CREDENTIALS_USER,
                  password: process.env.VUE_APP_ESEARCH_CREDENTIALS_PASS
               }
            }
         ).then(response => {
            this.data = response.data.hits;
            this.facets = response.data.aggregations;
            this.pager.totalResults = response.data.hits.total.value;
         })
      },

      changeSorting(event) {
         if(event == '_score'){
            this.sort = [{"_score": {"order":"desc"}}];
         }
         else{         
            this.sort = event;
         }
         this.search();
      },

      changePage(value){
         this.pager.from = this.pager.limit * (value - 1);
         this.pager.currentPage = value;         
         this.search();
      },

      setFilters(){
         this.filters.push({terms : {"data.argomenti.iv.keyword": this.argomento }});
      },

      setLimit(value){
         this.pager.limit = value;
         this.search();
      },           
   },

   mounted(){    
      this.search();
   },

   computed:{
      link: function () {        
         let nameType = this.$props.news.item._source.name;
         //let s3Area = this.$props.news.item._source.data.s3.iv;
         if(nameType === "S3Published"){
            return "/s3/" + this.$props.news.item._source.data.slug.iv;
         }
         else if(nameType === "SezionePublished"){
            return "/" + this.$props.news.item._source.data.slug.iv;               
         }
         else if(nameType === "ArticoloPublished"){
            if(this.$props.news.item._source.data.s3.iv !== null){
               return this.getPath(this.$props.news.item._source.data.s3.iv) +'/'+ this.$props.news.item._source.data.slug.iv;            
            }else{
               return "/s3/" + this.$props.news.item._source.data.slug.iv;
            }
         }
         else if(nameType === "AreeSpecializzazionePublished"){
            return "/aree-di-specializzazione/" + this.$props.news.item._source.data.slug.iv;
         }
         else if(nameType === "PartecipantiPublished"){
             return "/partecipanti/" + this.$props.news.item._source.data.slug.iv;
         }
         else{
            return "/notizie-e-eventi/" + this.$props.news.item._source.data.slug.iv;            
         }
      },
      getArea: function(){
         let typeArea = this.$props.news.item._source.schemaId.split(',').pop();
         if(typeArea == 'articolo'){
            return this.getNameSezione(this.$props.news.item._source.data.s3.iv);
         }
         else{
            return typeArea.replace('-', ' ');
         }
      },            
   },
    watch: {
        $route: {
            handler: function() {
               this.query = this.$route.params.slug;
               this.search();               
            }
        }
    }   
};
</script>
<style scoped>
.read-more {
   color: #003594;
   text-transform: uppercase;
   font-weight: bold;
   letter-spacing: .9px;
   font-size: .77778rem;
}
</style>
